import React from "react";

export default function TermsConditions() {
  return (
    <main data-testid="terms-page" className="pt-28 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-['Playfair_Display'] text-white mb-8">Terms & Conditions</h1>
        <div className="prose prose-invert max-w-none space-y-6 text-gray-400">
          <p className="text-sm">Last updated: January 2026</p>
          <h2 className="text-white text-xl font-semibold mt-8">1. Acceptance of Terms</h2>
          <p>By accessing and using Digitronix Consultancy LLC's website and services, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.</p>
          <h2 className="text-white text-xl font-semibold mt-8">2. Services</h2>
          <p>Digitronix Consultancy provides digital consulting, software development, and technology solutions. The scope, timeline, and deliverables for each project will be defined in a separate service agreement.</p>
          <h2 className="text-white text-xl font-semibold mt-8">3. Intellectual Property</h2>
          <p>All content, designs, code, and materials created by Digitronix Consultancy remain our intellectual property until full payment is received and ownership is transferred as specified in the project agreement.</p>
          <h2 className="text-white text-xl font-semibold mt-8">4. Limitation of Liability</h2>
          <p>Digitronix Consultancy shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.</p>
          <h2 className="text-white text-xl font-semibold mt-8">5. Contact</h2>
          <p>For any questions regarding these Terms, please contact us at info@digitronixconsultancyllc.com</p>
        </div>
      </div>
    </main>
  );
}
